import React from 'react';

const PageHero = ({ eyebrow, title, lede }) => (
    <div className="tm-page-hero">
        <div className="tm-page-hero__inner">
            <span className="tm-eyebrow tm-rise">{eyebrow}</span>
            <h1 className="tm-page-hero__title tm-rise-1">{title}</h1>
            {lede && <p className="tm-page-hero__lede tm-rise-2">{lede}</p>}
        </div>
    </div>
);

export default PageHero;



// WEBPACK FOOTER //
// ./src/components/common/PageHero.js